var widget_default = {
  "card": "vRTKZ",
  "link": "Ytdak",
  "container": "A5Nzi",
  "image": "S9BwM",
  "right": "UQTcb",
  "cardLayout": "MKJS8",
  "content": "fmBG0",
  "title": "_62j-m",
  "subtitle": "u5FbD",
  "button": "cXzKI",
  "button_disabled": "_1Z8Bq",
  "buttonText": "_3djDR",
  "slimLayout": "miXEh",
  "contentText": "iQ75U"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
